/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiDocumentShareScope {
    Fund = 'FUND',
    Company = 'COMPANY',
    Person = 'PERSON'
}

export function ApiDocumentShareScopeFromJSON(json: any): ApiDocumentShareScope {
    return ApiDocumentShareScopeFromJSONTyped(json, false);
}

export function ApiDocumentShareScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiDocumentShareScope {
    return json as ApiDocumentShareScope;
}

export function ApiDocumentShareScopeToJSON(value?: ApiDocumentShareScope | null): any {
    return value as any;
}

